// extracted by mini-css-extract-plugin
export default {"container":"projectDetails_container__Iy1zq"};